import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import Styled from './backdrop.styles';

// TODO: add story for this component?
var Backdrop = intrinsicComponent(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(Styled.Backdrop, _extends({}, rest, {
    ref: ref
  }));
});
export default Backdrop;